export abstract class TsColorUtils {
  /*
   * Determines if the contrast color is light or dark based on the provided hex color.
   * Used for providing contrast for text in different background colors.
   */
  static isContrastLight(colorHex: string): boolean {
    if (typeof colorHex !== 'string' || colorHex.length < 7) return false;

    const r = parseInt(colorHex.slice(1, 3), 16);
    const g = parseInt(colorHex.slice(3, 5), 16);
    const b = parseInt(colorHex.slice(5, 7), 16);

    // The RGB values are converted to grayscale using the NTSC formula: 0.299 ∙ Red + 0.587 ∙ Green + 0.114 ∙ Blue.
    // This formula closely represents the average person's relative perception of the brightness of red, green, and blue light.
    // https://support.ptc.com/help/mathcad/r9.0/en/index.html#page/PTC_Mathcad_Help/example_grayscale_and_color_in_images.html
    const overallColorIntensity = r * 0.299 + g * 0.587 + b * 0.114;
    const intensityThreshold = 150;

    return overallColorIntensity < intensityThreshold;
  }
}
